import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  query,
  orderBy,
  doc,
  updateDoc,
  deleteDoc, // ✅ imeongezwa
} from 'firebase/firestore';


const AdminCommissionHistory = () => {
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editAmounts, setEditAmounts] = useState({});

  // Fetch commissions
  useEffect(() => {
    const fetchHistory = async () => {
      setLoading(true);
      setError(null);
      try {
        const q = query(
          collection(db, 'commissions'),
          orderBy('changedAt', 'desc')
        );
        const snapshot = await getDocs(q);

        const data = snapshot.docs.map(docSnap => {
          const d = docSnap.data();
          return {
            id: docSnap.id,
            username: d.username || 'N/A',
            amount: d.amount || 0,
            status: d.status || 'unknown',
            currency: d.commissionCurrency || 'TSH',
            changedAt: d.changedAt?.toDate() || null,
          };
        });

        setCommissions(data);
      } catch (err) {
        console.error('Error loading history:', err);
        setError('Imeshindikana kupakia historia ya commissions.');
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  // ✅ Badilisha status
  const handleStatusChange = async (id, newStatus) => {
    try {
      const docRef = doc(db, 'commissions', id);
      await updateDoc(docRef, {
        status: newStatus,
        changedAt: new Date(),
      });

      setCommissions(prev =>
        prev.map(c =>
          c.id === id ? { ...c, status: newStatus, changedAt: new Date() } : c
        )
      );
    } catch (err) {
      console.error('Update error:', err);
      alert('Imeshindikana kubadilisha status. Jaribu tena.');
    }
  };

  // ✅ Save amount
  const handleAmountSave = async id => {
    const newAmount = editAmounts[id];
    if (!newAmount || isNaN(newAmount)) return;

    try {
      const docRef = doc(db, 'commissions', id);
      await updateDoc(docRef, {
        amount: Number(newAmount),
        changedAt: new Date(),
      });

      setCommissions(prev =>
        prev.map(c =>
          c.id === id
            ? { ...c, amount: Number(newAmount), changedAt: new Date() }
            : c
        )
      );

      setEditAmounts(prev => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });
    } catch (err) {
      console.error('Update error:', err);
      alert('Imeshindikana kubadilisha kiasi. Jaribu tena.');
    }
  };

  // ✅ Function ya kufuta commission yoyote
  const handleDelete = async id => {
    const confirmDelete = window.confirm(
      'Una uhakika unataka kufuta commission hii?'
    );
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, 'commissions', id));

      setCommissions(prev => prev.filter(c => c.id !== id));
      alert('Commission imefutwa kikamilifu.');
    } catch (err) {
      console.error('Delete error:', err);
      alert('Imeshindikana kufuta commission. Jaribu tena.');
    }
  };

  if (loading) return <div>Inapakia...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (commissions.length === 0)
    return <div>Hakuna historia ya commission.</div>;

  return (
    <div className="admin-history-container">
      <h2>Admin Commission History</h2>
      <table className="admin-history-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Amount</th>
            <th>Currency</th>
            <th>Status</th>
            <th>Date Changed</th>
            <th>Action</th>
            <th>Delete</th> {/* ✅ imeongezwa */}
          </tr>
        </thead>
        <tbody>
          {commissions.map(c => (
            <tr key={c.id}>
              <td>{c.username}</td>
              <td>
                {c.status === 'success' ? (
                  <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                    <input
                      type="number"
                      value={editAmounts[c.id] ?? c.amount}
                      onChange={e =>
                        setEditAmounts(prev => ({
                          ...prev,
                          [c.id]: e.target.value,
                        }))
                      }
                      style={{ width: '100px' }}
                    />
                    <button onClick={() => handleAmountSave(c.id)}>Save</button>
                  </div>
                ) : (
                  Number(c.amount).toLocaleString()
                )}
              </td>
              <td>{c.currency}</td>
              <td className={`status-${c.status}`}>{c.status}</td>
              <td>{c.changedAt ? c.changedAt.toLocaleString('en-GB') : '-'}</td>
              <td>
                <select
                  value={c.status}
                  onChange={e => handleStatusChange(c.id, e.target.value)}
                >
                  <option value="waiting">Waiting</option>
                  <option value="processing">Processing</option>
                  <option value="success">Success</option>
                </select>
              </td>

              {/* ✅ Button ya kufuta */}
              <td>
                <button
                  onClick={() => handleDelete(c.id)}
                  style={{
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Futa
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminCommissionHistory;